const d3 = require("d3"),
      c = require("infra/utils/common"),
      $ = require("jquery");
const _ = require('lodash');

const PAD = {
    left: 50,
    right: 20,
    top: 20,
    bottom: 30
};
const HOVER_PAD = 0;
const HOVER_OVERLAY = -2;
const HOVER_HEIGHT = 18;
const HOVER_WIDTH = 42;
const HOVER_TEXT_PAD = 13;
const HOVER_Y = -7;
const SHOW_DATE = true;

const DEFAULT_INTERPOLATION = 'monotone';
const MIN_X_TICK_SPACE = 80;
const MAX_X_TICK_SPACE = 130;
const AXIS_COLOR = 'rgba(255,255,255,0.1)';
const Y_AXIS_MAXIMUM_LINES = 15;
const Y_AXIS_LINES = 10;
const Y_AXIS_MINIMUM_LINES = 5;
const Y_AXIS_DEFAULT_MAX = 103;
const DEFAULT_Y_AXIS = false;

d3.selection.prototype.moveToFront = function() {
    return this.each(function() {
        this.parentNode.appendChild(this);
    });
};

function getNumTicks(chartHeight) {
    if (chartHeight > 285) return Y_AXIS_MAXIMUM_LINES;
    if (chartHeight < 185) return Y_AXIS_MINIMUM_LINES;
    return Y_AXIS_LINES;
}

function StackedChart(containing_object, id, entries, line, configuration) {
    let previous = null;
    let self = this;
    this.id = id;
    this.containing_object = containing_object || {};
    this.initialized = false;
    this.fill = line ? 'line' : 'area';
    this.configuration = c.is(configuration) ? configuration : {};
    this.minutes = 'minutes' === this.configuration.type;
    this.range = [];
    this.wide = false;
    this.entries = entries;
    this.letterClicked = '';
    this.withFbCutoffDate = false;
    this.withSimWebDate = false;

    Object.defineProperty(this, "dateFormat", {
        set: function(value) {
            this.parseDate = d3.time.format(value).parse;
            this.toStringDate = d3.time.format(value);
        }
    });

    _.each(this.entries, function(entry, i) {
        entry.previous = previous;
        previous = entry;
    });

    this.clean = function() {
        this.infoMap = {};
        this.currentInfo = null;
        this.delta = 0;
        this.move = null;
        this.range = [];
        if (c.is(this.svg)) {
            this.svg.selectAll(".line, .area, g.y-axis, .stacked-chart-circle, .stacked-chart-text, .stacked-chart-line").remove();
        }
        if (c.is(this.info)) {
            this.info.selectAll("*").remove();
        }
    };

    this.init = function() {
        if (!this.initialized) {
            this.initialized = true;
            this.clean();
            this.dateFormat = this.minutes ? "%Y-%m-%dT%H:%M:%S.%LZ" : "%d-%m-%Y";
            let root = $(document.getElementById(this.id));
            let self = this;
            root.mouseleave(function() {
                if (c.is(self.currentInfo))
                    self.currentInfo.style("opacity", 1e-6);
            });
            this.container = d3.select(document.getElementById(this.id));
            this.svg = this.container.append("svg")
                .attr("height", "100%")
                .attr("id","svg-container");
            this.container.select("svg")
                .attr("style","position:absolute;");
            this.svg = this.svg.append("g")
                .attr("id", "canvas");
            this.svg.append("g")
                .attr("class", "x-axis axis");
            this.domain = this.svg.append("g")
                .attr("stroke", "none")
                .attr("class", "y-axis axis");
            let gy = this.svg.select("g.y-axis.axis");
            gy.select("path.domain").attr("id", "domain");
            this.info = this.svg.append("g").attr("id", "info");
            return false;
        }
        return true;
    };

    this.draw = function(data, range, max, wide) {
        this.init();
        this.clean();
        this.wide = wide;
        if (c.is(data) && c.isArray(range) && c.isArray(data.series) && c.is(data.term)) {
            let self = this;
            this.range = range;
            this.updateLayout(range, max, data.midnight);
            this.addLines(data);
            self.addInfo(data);
            self.addInfoTooltips();
            if (self.configuration.agg_examples_mode) {
                self.addCircles(data.examples);
            }
        }
    };

    this.updateLayout = function(range, max, minutes) {
        let self = this;
        let root = $(document.getElementById(this.id));
        this.width = root.width() - PAD.left - PAD.right;
        this.height = root.height() - PAD.top - PAD.bottom;
        this.svg.attr("transform", "translate(" + PAD.left + "," + PAD.top + ")");
        this.xScale = d3.time.scale().range([0, this.width]);
        this.yScale = d3.scale.linear().range([this.height, HOVER_PAD]);
        this.svg.select("g.x-axis").attr("transform", "translate(0," + this.height + ")");
        this.svg.append("g").attr("class", "y-axis axis");

        let ticks = self.wide ? ((this.width / MAX_X_TICK_SPACE) | 0) : ((this.width / MIN_X_TICK_SPACE) | 0);
        ticks = (ticks > range.length) ? range.length : ticks;
        let usedDates = [];
        let xAxis = d3.svg.axis()
            .scale(this.xScale)
            .orient("bottom")
            .ticks(ticks)
            .tickSize(0)
            .tickPadding(10)
            .tickFormat(function (d, index) {
                if (c.isString(self.configuration.type) && self.minutes) {
                    if (self.wide) {
                        return (d.getMonth() + 1) + '/' + d.getDate() + ' ' + c.getHoursLabel(d, /*minutes*/true);
                    }
                    return c.getHoursLabel(d);
                } else {
                    const formatted = (d.getMonth() + 1) + '/' + d.getDate();
                    if(usedDates.indexOf(formatted) === -1){
                        usedDates.push(formatted);
                        return formatted;
                    }
                }
                return '';
            });

        this.xScale.domain(d3.extent(range));
        this.svg.selectAll("g.x-axis").call(xAxis);
        let yAxisMax = Y_AXIS_DEFAULT_MAX;
        if (c.isNumber(max) && max > 0) {
            if (self.configuration.force_max || max <= 100) {
                yAxisMax = max + (max/100) * 3;
            }
        }
        this.yScale.domain([HOVER_PAD, yAxisMax]);
        let yAxis = d3.svg.axis()
            .scale(this.yScale)
            .orient("left")
            .ticks(getNumTicks(self.height))
            .tickFormat((d) => (d >= 10000) ? d/1000 + 'K' : ((d === 0) ? '' : d))
            .tickSize(-this.width);
        this.svg.selectAll("g.y-axis").call(yAxis);
        if (!DEFAULT_Y_AXIS) {
            this.svg.selectAll("g.y-axis text")
                .attr("y", -10)
                .attr("x", -11);
            this.svg.selectAll("g.y-axis .tick line")
                .attr("x1", -10)
                .attr("y1", 0);
            this.svg.selectAll("g.y-axis .tick").append("svg:line")
                .attr("x1", (d) => (d === 0) ? 0 : -2)
                .attr("y1", 0)
                .attr("x2", (d) => (d === 0) ? 0 : -30)
                .attr("y2", 0)
                .style("stroke", AXIS_COLOR)
                .attr("class", "small-ticks");
        }
    };

    this.addLines = function(data) {
        let self = this;
        const path = this.svg.selectAll("path.line").data([data]);
        _.each(this.entries, (entry, i) => self.addLine(path, data, entry));
    };

    this.addInfo = function(data) {
        if (c.isArray(data.series)) {
            let self = this, px = 0, cx = 0;
            let max = self.xScale(data.series[data.series.length - 1].date);
            _.each(data.series, function (tick, j) {
                if (c.isDate(tick.date)) {
                    cx = self.xScale(tick.date);
                    max = (cx > max) ? cx : max;
                    self.delta = px > 0 ? (self.minutes ? (cx - px) : (px - cx)) + self.delta : self.delta;
                    c.addMapItemByDate(self.infoMap, self.getInfo(self.entries, tick, cx, max, data.series), tick.date, self.minutes);
                    px = cx;
                }
            });
            this.delta = (this.delta / (data.series.length - 1))/2;
        } else {
            this.delta = 0;
        }
    };

    this.addLine = function(path, data, entry) {
        let interpolationFunc, self = this;
        if (self.fill === 'line') {
            interpolationFunc = d3.svg.line().interpolate(DEFAULT_INTERPOLATION)
                .x((d) => self.xScale(d.date))
                .y((d) => self.yScale(d[entry.key]));
        } else {
            interpolationFunc = d3.svg.area().interpolate(DEFAULT_INTERPOLATION)
                .x((d) => self.xScale(d.date))
                .y0((d) => c.is(d.previous) ? self.yScale(d[d.previous.key]) : self.height)
                .y1((d) => self.yScale(d[entry.key]));
        }
        path.enter().append("path")
            .attr("class", self.fill + ' ' + entry.class)
            .attr("id", (d) => 'line-' + entry.key + '-' + d.term.id)
            .attr("d", (d) => interpolationFunc(d.series))
            .attr("tkey", (d) => entry.key + '-' + d.term.id);
    };

    this.getInfoPosition = function(entries, xPos, max) {
        const width = (SHOW_DATE ? entries.length + 1 : entries.length) * HOVER_WIDTH;
        const infoPos = xPos - width / 2 + (SHOW_DATE ? HOVER_WIDTH/2 : 0);
        if (infoPos < 0) {
            return 0;
        }
        if (infoPos + width > max) {
            return (max - width);
        }
        return infoPos;
    };

    this.getInfo = function(entries, tick, xPos, max, series) {
        let self = this;
        const dateKey = c.getDateKey(tick.date, self.minutes, '-', false);
        const isCutoff = isCutoffDate(dateKey, series);
        let infoGroup = self.info.append("g")
            .attr("id", 'info-group-' + dateKey)
            .attr("dkey", dateKey)
            .style("opacity", 1e-6);
        if (isCutoff) {
            self.info.append("line")
                .attr("stroke", "#ababab")
                .attr("stroke-dasharray", "10,5")
                .attr("x1", xPos)
                .attr("x2", xPos)
                .attr("stroke-width", 1)
                .attr("y1", 0)
                .attr("y2", self.height);
        } else {
            infoGroup.append("line")
                .attr("stroke", "#cacaca")
                .attr("x1", xPos)
                .attr("x2", xPos)
                .attr("stroke-width", 1)
                .attr("y1", 0)
                .attr("y2", self.height);
        }
        let entryIndex = 0, infoMargin = 0, textMargin = 0;
        let infoPosition = this.getInfoPosition(entries, xPos, max);
        const cutoffType = c.getCutoffType(dateKey, series);
        const cutoffTextMargin = tick.date.getDate() > 9 ? 9 : 6;
        let descriptionX = infoPosition + HOVER_WIDTH * 3 + HOVER_TEXT_PAD - cutoffTextMargin;
        if (isCutoff) {
            const cutoffHoverWidth = c.getCutoffHoverWidth(cutoffType);
            if(descriptionX + cutoffHoverWidth > max ) {
                const cutoffMaxPosDiff = descriptionX + cutoffHoverWidth - max + c.CUTOFF_EDGE_OFFSET;
                descriptionX -= cutoffMaxPosDiff;
                infoPosition -= cutoffMaxPosDiff;
            }
        }

        _.each(entries, function(entry) {
            let tickText = 0 + entry.units;
            if (tick.value > 0) {
                tickText = Math.round(tick[entry.source]*10)/10 + entry.units;
            }
            infoMargin = HOVER_WIDTH * entryIndex;
            textMargin = (tickText.length * 3) / 2;
            infoGroup.append("rect")
                .attr("x", infoPosition + infoMargin)
                .attr("y", HOVER_OVERLAY - HOVER_HEIGHT)
                .attr("width", HOVER_WIDTH)
                .attr("height", HOVER_HEIGHT)
                .attr("class", entry.class);
            let text = infoGroup.append("text")
                .attr("x", infoPosition + infoMargin + HOVER_TEXT_PAD - textMargin)
                .attr("y", HOVER_Y)
                .attr("class", "hover-text")
                .text(tickText);
            entryIndex++;
        });
        if (SHOW_DATE) {
            infoMargin = HOVER_WIDTH * entryIndex;
            infoGroup.append("rect")
                .attr("x", infoPosition)
                .attr("y", HOVER_OVERLAY - HOVER_HEIGHT)
                .attr("width", HOVER_WIDTH)
                .attr("height", HOVER_HEIGHT)
                .attr("class", "unknown-stack"); // hover-date
            const description = isCutoff ? c.getCutoffText(cutoffType) :
                                                 (self.minutes ? c.getHoursLabel(tick.date) :
                                                                (tick.date.getMonth() + 1) + '/' + tick.date.getDate());
            infoGroup.append("text")
                .attr("x", descriptionX)
                .attr("y", HOVER_Y)
                .attr("class", "hover-date-text")
                .text(description);
            entryIndex++;
        }
        return infoGroup;
    };

    this.findDateItem = function(date) {
        let item = c.getMapItemByDate(this.infoMap, date, this.minutes, false);
        if (!c.is(item)) {
            let previousItem, nextItem;
            _.each (this.range, function(entry) {
                if (date > entry) {
                    previousItem = (previousItem && previousItem > entry) ? previousItem : entry;
                } else {
                    nextItem = (nextItem && nextItem < entry) ? nextItem : entry;
                }
            });
            previousItem = c.is(previousItem) ? previousItem : nextItem;
            nextItem = c.is(nextItem) ? nextItem : previousItem;
            if (c.is(nextItem) && c.is(previousItem)) {
                const previous_item_offset = date.getTime() - previousItem.getTime();
                const next_item_offset = nextItem.getTime() - date.getTime();
                const item_date = (previous_item_offset > next_item_offset ? nextItem : previousItem);
                item = c.getMapItemByDate(this.infoMap, item_date, this.minutes, false);
            }
        }
        return item;
    };

    this.updateTooltip = function(infoGroup) {
        if (c.is(infoGroup)) {
            if (infoGroup !== this.currentInfo) {
                if (c.is(this.currentInfo)) {
                    this.currentInfo.style("opacity", 1e-6);
                }
                infoGroup.style("opacity", 1);
                this.info.moveToFront();
                infoGroup.moveToFront();
                this.currentInfo = infoGroup;
            } else {
                infoGroup.style("opacity", 1);
            }
            return true;
        }
        return false;
    };

    this.addInfoTooltips = function() {
        let self = this;
        setTimeout( function() {
            self.container.on("mousemove", function(e) {
                try {
                    const fx = d3.mouse(this)[0] - PAD.left;
                    const date = self.xScale.invert(fx + self.delta/2);
                    const key = self.container.attr("key");
                    const dateInfoGroup = self.findDateItem(date);
                    const dateKey = dateInfoGroup.attr('dkey');

                    self.updateTooltip(dateInfoGroup);
                    self.move = fx;
                    self.moveCircleToFront(dateKey, key)
                } catch (e) {}
            });
        }, 0 );
    };

    this.addCircles = function(data) {
        let self = this;

        if(c.isArray(data)) {
            _.each(data, function (entry, i) {
                const key = c.getKey(entry.trend_id, entry.trend_text);
                const dateKey = c.getDateKey(entry.date, false, '-', false);
                const cx = self.xScale(entry.date);
                const cy = self.yScale(entry.value) - 20;
                self.svg.append("circle")
                    .attr("class", "stacked-chart-circle")
                    .attr("id", 'stacked-chart-circle-' + key + '-' + dateKey)
                    .attr("pdate", dateKey)
                    .attr("cx", cx)
                    .attr("cy", cy)
                    .attr("letter", entry.letter)
                    .attr("key", key)
                    .attr("sentiment", entry.sentiment)
                    .on("mouseover", function () {
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        self.highlightSwitchIdValues(element, true, "circle", "text");
                        self.emitEvent("chartCircleMouseover", currentLetter);
                        self.moveCircleToFront(currentLetter);
                    }).on("mouseout", function () {
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        if (currentLetter !== self.letterClicked) {
                            self.highlightSwitchIdValues(element, false, "circle", "text");
                        }
                        self.emitEvent("chartCircleMouseout", currentLetter);
                    }).on("click", function () {
                        self.highlightCircleFromLetter(self.letterClicked, false);
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        self.letterClicked = currentLetter;
                        self.highlightSwitchIdValues(element, true, "circle", "text");
                        self.moveCircleToFront(currentLetter);
                        self.emitEvent("chartCircleClick", {letter: currentLetter, sentiment: element.attr("sentiment")});
                        d3.event.stopPropagation();
                    });

                self.svg.append("text")
                    .attr("class", "stacked-chart-text")
                    .attr("id", 'stacked-chart-text-' + key + '-' + dateKey)
                    .attr("pdate", dateKey)
                    .attr("x", cx)
                    .attr("y", cy)
                    .attr("letter", entry.letter)
                    .attr("key", key)
                    .attr("sentiment", entry.sentiment)
                    .text(entry.letter)
                    .on("mouseover", function () {
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        self.highlightSwitchIdValues(element, true, "text", "circle");
                        self.emitEvent("chartCircleMouseover", currentLetter);
                        self.moveCircleToFront(currentLetter);
                    }).on("mouseout", function () {
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        if (currentLetter !== self.letterClicked) {
                            self.highlightSwitchIdValues(element, false, "text", "circle");
                        }
                        self.emitEvent("chartCircleMouseout", currentLetter);
                    }).on("click", function () {
                        self.highlightCircleFromLetter(self.letterClicked, false);
                        let element = d3.select(this);
                        const currentLetter = element.attr("letter");
                        self.letterClicked = currentLetter;
                        self.highlightSwitchIdValues(element, true, "text", "circle");
                        self.moveCircleToFront(currentLetter);
                        self.emitEvent("chartCircleClick", {letter: currentLetter, sentiment: element.attr("sentiment")});
                        d3.event.stopPropagation();
                    });

                self.svg.append("line")
                    .attr("class","stacked-chart-line")
                    .attr("x1", cx)
                    .attr("x2", cx)
                    .attr("y1", cy + 5)
                    .attr("y2", cy + 20)
                    .attr("stroke", "#cacaca")
                    .attr("stroke-width", 1);

                if(cy < 10) {
                    d3.selectAll("#" + self.id + " #info-group-" + dateKey + " rect").attr("y", cy + 15);
                    d3.selectAll("#" + self.id + " #info-group-" + dateKey + " text").attr("y", cy + 28);
                }

                if (self.letterClicked) {
                    self.highlightCircleFromLetter(self.letterClicked, true);
                }
            });

            d3.selectAll(".stacked-chart-circle, .stacked-chart-text").moveToFront();
        }
    };

    this.resetHighlightedCircle = function() {
        this.highlightCircleFromLetter(this.letterClicked, false);
        this.letterClicked = '';
    };

    this.moveCircleToFront = function (dateKey, key) {
        this.getStackedChartElement("circle", dateKey, key).moveToFront();
        this.getStackedChartElement("text", dateKey, key).moveToFront();
    };

    this.highlightSwitchIdValues = function(element, highlightOn, searchValue, replaceValue) {
        element.classed("highlighted", highlightOn);
        const elementId = element.attr("id").replace(searchValue, replaceValue);
        d3.select("#" + elementId).classed("highlighted", highlightOn);
    };

    this.highlightCircleFromLetter = function(letter, highlightOn) {
        if (letter) {
            d3.select(".stacked-chart-circle[letter=" + letter + "]").classed("highlighted", highlightOn);
            d3.select(".stacked-chart-text[letter=" + letter + "]").classed("highlighted", highlightOn);
        }
    };

    this.getStackedChartElement = function(type, dateKey, key){
        return d3.select(".stacked-chart-" + type + "[pdate=\"" + dateKey + "\"][key=\"" + key + "\"]");
    };

    this.emitEvent = function(eventType, data) {
        if (self.containing_object.hasOwnProperty('emitEventForChartCircle') &&
            typeof self.containing_object.emitEventForChartCircle == 'function'){
            self.containing_object.emitEventForChartCircle(eventType, data);
        }
    };

    this.setWithSimWebDate = function(value) {
        self.withSimWebDate = value;
    };

    function isCutoffDate(dateKey, dates) {
        return self.withSimWebDate && dateKey === c.getSimWebCutoffDate(dates);
    }
}

module.exports = StackedChart;